/**
 * WEB-3956 юнит 8 — раздел маршрутов «организация»: страницы-дети
 * `DashboardLayout` уровня организации (под входом, следом за страницами
 * проекта `project.tsx`); собирает `router/index.tsx`.
 */
import { Navigate, type RouteObject } from 'react-router-dom';
import { lazyWithRetry } from '@/utils/lazyWithRetry';
import { CabinetSuspense } from '../suspense';
import { AuditPage } from './project';

// WEB-340: Org-level nav route stubs (project list + team + billing)
const OrgProjectsPage = lazyWithRetry(
  () => import('@/pages/OrgProjects'),
  'page:OrgProjects',
);
const OrgBalancePage = lazyWithRetry(
  () => import('@/pages/OrgBalance'),
  'page:OrgBalance',
);
// WEB-344: Org-level aggregate dashboard
const OrgDashboardPage = lazyWithRetry(
  () => import('@/pages/OrgDashboard'),
  'page:OrgDashboard',
);
// WEB-390: Org-level domains list
const OrgDomainsPage = lazyWithRetry(
  () => import('@/pages/OrgDomains'),
  'page:OrgDomains',
);

// WEB-340: Org-mode routes (visible when currentProject === null in sidebar)
export const ORG_ROUTES: RouteObject[] = [
  // WEB-344: /org/dashboard — aggregate analytics dashboard
  {
    path: 'org/dashboard',
    element: <CabinetSuspense><OrgDashboardPage /></CabinetSuspense>,
  },
  {
    path: 'projects',
    element: <CabinetSuspense><OrgProjectsPage /></CabinetSuspense>,
  },
  {
    // WEB-643 A3: «Организация» переехала в 4-ю вкладку личных Настроек
    // (Settings.tsx) — старый URL редиректит на вкладку «Команда» там
    // (не 404).
    path: 'org/team',
    element: <Navigate to="/settings?tab=org&orgTab=team" replace />,
  },
  {
    path: 'org/balance',
    element: <CabinetSuspense><OrgBalancePage /></CabinetSuspense>,
  },
  {
    // WEB-2312: пять кнопок «Пополнить» вели на /billing — такого адреса
    // в кабинете не было (третий адрес класса WEB-1246). Кнопки ведут на
    // «Баланс» через дверь useOrgTopUp; старые ссылки в письмах и
    // закладках — сюда. Слово занято и на сервере (RESERVED_APEX_SLUGS).
    path: 'billing',
    element: <Navigate to="/org/balance" replace />,
  },
  {
    path: 'org/domains',
    element: <CabinetSuspense><OrgDomainsPage /></CabinetSuspense>,
  },
  {
    // Аудит организации: журнал действий команды + трафик всей орги.
    path: 'org/audit',
    element: <CabinetSuspense><AuditPage scope="org" /></CabinetSuspense>,
  },
  {
    // WEB-643 A3: /org/settings retired as a standalone page (PM decision,
    // canon settings-mockup/src/SettingsPage.tsx) — «Организация» is now
    // the 4th tab of the personal Settings page. Old bookmarks/links
    // redirect here instead of 404ing.
    path: 'org/settings',
    element: <Navigate to="/settings?tab=org" replace />,
  },
];
